import {
  addMilliseconds,
  endOfDay,
  isAfter,
  isBefore,
  startOfDay,
} from 'date-fns'

import { createTime } from '../../../utils/date'

/**
 * @typedef {Object} TimePickerSelectOption
 * @property {string} label
 * @property {Date} value
 */

/**
 *
 * @param {Date} value
 * @param {(value: Date) => string} [format]
 *
 * @returns {TimePickerSelectOption}
 */
export function getTimePickerSelectOption(format, value) {
  return { label: format(value), value }
}

/**
 * Builds the full-day list of time options at `step` intervals, bounded by
 * `minValue` / `maxValue`.
 *
 * @returns {TimePickerSelectOption[]}
 */
export function getTimePickerOptions({
  formatLabel,
  maxValue,
  minValue,
  step,
}) {
  const options = []

  if (step > 0) {
    const min = startOfDay(createTime())
    const max = endOfDay(min)

    let time = min

    while (!isAfter(time, max)) {
      if (
        (!minValue || !isBefore(time, minValue)) &&
        (!maxValue || !isAfter(time, maxValue))
      ) {
        options.push(getTimePickerSelectOption(formatLabel, time))
      }

      time = addMilliseconds(time, step)
    }
  }

  return options
}
